import { Dispatch } from 'react';
import { Article, BreadcrumbItems } from '../../../interface';
import getFlagValue from '../../utils/getFlagValue';
import { addQueuePromoCount, resetQueuePromoCount } from '../../../store/emarsys/action';
import { dateFormatterEmarsysReverseMonthDate } from '../../utils/dateFormatter';
import { FLAG_ENUM } from '../../utils/getFlagValue';

export const promoButtonClickOption = {
  mintaPenawaran: 'minta penawaran',
  lihatSemuaPromo: 'lihat semua',
  whatsapp: 'social_share_button_whatsapp',
  facebook: 'social_share_button_facebook',
  x: 'social_share_button_x',
  tiktok: 'social_share_button_tiktok',
  shareCopylink: 'social_share_button_copylink',
};

export default function eventClickPromo(
  dispatch: Dispatch<any>,
  promo: Article,
  breadcrumbItems: BreadcrumbItems[],
  customerNo: string,
  buttonName: string,
  sectionName: string
) {
  const isFlagActive = getFlagValue(FLAG_ENUM.EMARSYS);
  const isPromoActive = getFlagValue(FLAG_ENUM.EMARSYS_PROMO);
  if (!isFlagActive || !isPromoActive) return;
  if (customerNo) {
    ScarabQueue.push(['setCustomerId', customerNo]);
  }

  const valuePageView: Record<string, string | number | boolean> = {
    page_name: 'promo detail page',
    page_title: promo?.titlePage || '',
    page_url: window.location.href,
    ...(breadcrumbItems?.[1]?.name && {
      menu_cat_lvl1: breadcrumbItems[1].name.toLowerCase(),
    }),
    ...(breadcrumbItems?.[2]?.name && {
      menu_cat_lvl2: breadcrumbItems[2].name.toLowerCase(),
    }),
    ...(breadcrumbItems?.[3]?.name && {
      menu_cat_lvl3: breadcrumbItems[3].name.toLowerCase(),
    }),
    section_name: sectionName,
    button_name: buttonName,
  };

  if (promo?.startDate && promo?.endDate) {
    valuePageView.promo_periode = `${dateFormatterEmarsysReverseMonthDate(promo?.startDate)} - ${dateFormatterEmarsysReverseMonthDate(promo?.endDate)}`;
  }

  if (promo?.model?.[0]) {
    valuePageView.car_model_1 = promo?.model?.[0];
  }
  if (promo?.model?.[1]) {
    valuePageView.car_model_2 = promo?.model?.[1];
  }
  if (promo?.model?.[2]) {
    valuePageView.car_model_3 = promo?.model?.[2];
  }

  ScarabQueue.push(['tag', 'click_button', valuePageView]);

  if (buttonName.includes('lihat semua')) {
    ScarabQueue.push(['go']);
    dispatch(resetQueuePromoCount());
  } else {
    dispatch(addQueuePromoCount());
  }
}
